<template>
  <div class="container">
    <loading-panel></loading-panel>
  </div>
</template>
<script>
import LoadingPanel from "@/components/LoadingPanel.vue";
import { getCookie } from "@/util/cookies";
import parseJwt from "@/util/parseJwt";

export default {
  name: "Loading",
  components: {
    LoadingPanel,
  },
  methods: {
    redirectTo() {
      const token = getCookie("token");
      if (!token) {
        window.location.replace("https://portal.htop.stechoq.com/auth/login");
      } else {
        const { role, divisionId } = parseJwt(token);
        console.log({ role }, { divisionId });
        if (role === 4 && divisionId !== 8) {
          this.$router.push({ name: "team-leader" });
        } else if (role === 3) {
          return this.$router.push({ name: "Member" });
        } else if (role === 2 && divisionId !== 8) {
          return this.$router.push({ name: "Manager" });
        } else if ((role === 4 || role === 2) && divisionId === 8) {
          this.$router.push({ name: "Finance" });
        }
      }
    },
  },
  created() {
    this.redirectTo();
  },
};
</script>
<style lang="scss" scoped>
.container {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
